import { DefaultTheme } from 'styled-components';

/**
 *  PNNL Color Guidelines: https://reputation.pnl.gov/default.aspx?topic=Colors
 */
declare module 'styled-components' {
  export interface DefaultTheme {
    fonts: {
      /** For regular text through */
      main: string;
      /** For Headings and attention grabbers */
      heading: string;
    };
    colors: {
      main: string;
      secondary: string;
      hover: string;
      disable: string;
      around: string;
      border: string;
    };
    backgrounds: {
      foreground: string;
      background: string;
      /** For active Theme */
      primary: string;
    };
    button: {
      color: string;
      background: string;
      hover: {
        color: string;
        border: string;
      };
      focus: string;
    };
    pnnl: {
      copper: string;
      silver: string;
      bronze: string;
      gold: string;
      platinum: string;
      onyx: string;
      emerald: string;
    };
    onFocus: {
      color: string;
      outline: string;
    };
    textColor: {
      color: string;
    };
    primary: string;
    font: string;
    secondaryFont: string;
    fontWeight: number;
    bgBlue: string;
    bgBlueShade: string;
    bgWhite: string;
    bgGrey: string;
    securityBlue: string;
    securityGray: string;
    securityDarkGray: string;
    securityWhite: string;
    securityRed: string;
    securityLightBlue: string;
    securityGreen: string;
    warningOrange: string;
    warningRed: string;
    warningYellow: string;
    iconBlue: string;
    iconGrey: string;
    lightFont: string;
    darkFont: string;
    contrast1: string;
    burgundy: string;
    fireyOrange: string;
    yellow: string;
    purpleBlue: string;
    greyBlue: string;
    teal: string;
  }
}

export const theme: DefaultTheme = {
  fonts: {
    main: 'Lato',
    heading: 'Ralewa',
  },
  colors: {
    main: '#000000',
    secondary: '#717171',
    hover: 'rgba(183, 183, 183, .4)',
    disable: '#bfbdbd',
    around: '#4D4D4D',
    border: '#D4D4D4',
  },
  backgrounds: {
    foreground: 'rgb(240,240,240)',
    background: '#FFFFFF',
    primary: '#007836',
  },
  button: {
    color: '#191C1F',
    background: '#F4AA00',
    hover: {
      color: '#191C1F',
      border: '#F4AA00',
    },
    focus: '#191C1F',
  },
  pnnl: {
    copper: '#D77600',
    silver: '#616265',
    bronze: '#A63F1E',
    gold: '#F4AA00',
    platinum: '#B3B3B3',
    onyx: '#191C1F',
    emerald: '#007836',
  },
  onFocus: {
    color: '#007836',
    outline: 'F4AA00',
  },
  textColor: {
    color: '#4A505E',
  },
  primary: '#ffffff',
  font: 'Lato',
  secondaryFont: 'Raleway',
  fontWeight: 100,
  bgBlue: '#16405C',
  bgBlueShade: '#44667C',
  bgWhite: '#ffffff',
  bgGrey: '#a8a8a8',
  securityBlue: 'rgb(0, 51, 102)',
  securityGray: 'rgb( 153, 153, 153)',
  securityDarkGray: 'rgb( 51, 51, 51)',
  securityWhite: 'rgb(255,255,255)',
  securityRed: 'rgb(204, 0, 51)',
  securityLightBlue: 'rba(0, 102, 153)',
  securityGreen: 'rgb(51, 153, 0)',
  warningOrange: '#c9621d',
  warningRed: '#f90000',
  warningYellow: '#fdcc03',
  iconBlue: '#253863',
  iconGrey: '#ced57',
  lightFont: '#ffffef',
  darkFont: '#000000',
  contrast1: '#fa8072',
  burgundy: '#54102b',
  fireyOrange: '#d25400',
  yellow: '#ff9900',
  purpleBlue: '#290f59',
  greyBlue: '#202b3d',
  teal: '#00827e',
};
